<template>
  <div class="progress-container">
    <div
      v-if="value"
      :style="{ width: `${value}%` }"
      class="progress-bar"
    />
    <div
      v-else
      class="progress-bar indeterminate"
    />
  </div>
</template>

<script setup>
defineProps({
  value: {
    type: Number,
    default: 0
  }
})
</script>

<style scoped>
.progress-container {
  width: 100%;
  height: 4px;
  background-color: var(--color-background-primary);
  border-radius: 2px;
  overflow: hidden;
}

.progress-bar {
  height: 100%;
  background-color: var(--primary-color);
  transition: width 0.2s ease;
}

.indeterminate {
  width: 50%;
  animation: indeterminate 1.5s infinite linear;
}

@keyframes indeterminate {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(200%);
  }
}
</style>
